import { createFileRoute } from "@tanstack/react-router";

import { BalanceHighlights } from "~/components/feature/balance/components";

export const Route = createFileRoute("/_app/dashboard/balance/highlights")({
  component: RouteComponent,
});

function RouteComponent() {
  return <BalanceHighlights />;
}
